import React, { useState } from 'react'
import { Tooltip } from 'antd';
import { DeleteOutlined } from "@ant-design/icons";

export default function DeleteOutlinedIcon() {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Tooltip title="Delete">
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <DeleteOutlined
                    style={{
                        fontSize: "20px",
                        color: !isHovered ? "rgb(163, 149, 218)" : "#1890ff",
                        transition: "transform 0.3s ease, color 0.3s ease",
                        transform: isHovered ? "scale(1.4)" : "scale(1)",
                    }}
                />
            </div>
        </Tooltip>
    );

}
